/**
 * FileName : wsState.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2023-07-25 16:01:00
 * Description :
 * -----
 * Last Modified: 2023-07-25 16:25:47
 * Modified By :
 * -----
 * Copyright (c) 2022 Magina Corporation. All rights reserved.
 */


const initState = {
    wsState: false,
};

export const CONNECT_STATE = 'connect_state';

export type ACTION = {
  type: typeof CONNECT_STATE ;
  value: boolean;
}

/**
 * 设置用户账户
 * @param {initState} state state
 * @param {ACTION} action action
 * @returns {state} state
 */
export const connectWs = (state = initState, action: ACTION) => {
    switch (action.type) {
        case CONNECT_STATE:
            state.wsState = action.value;
            return {...state, wsState: action.value};
        default:
            return state;
    }
};
